// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Billing Account API
 * Endpoints for managing billing accounts, marketplaces, payment processors, and entitlements.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Override } from './Override';
import {
  OverrideFromJSON,
  OverrideFromJSONTyped,
  OverrideToJSON,
  OverrideToJSONTyped,
} from './Override';

/**
 *
 * @export
 * @interface GetOverridesResponse
 */
export interface GetOverridesResponse {
  /**
   *
   * @type {Array<Override>}
   * @memberof GetOverridesResponse
   */
  data?: Array<Override>;
}

/**
 * Check if a given object implements the GetOverridesResponse interface.
 */
export function instanceOfGetOverridesResponse(
  value: object,
): value is GetOverridesResponse {
  return true;
}

export function GetOverridesResponseFromJSON(json: any): GetOverridesResponse {
  return GetOverridesResponseFromJSONTyped(json, false);
}

export function GetOverridesResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GetOverridesResponse {
  if (json == null) {
    return json;
  }
  return {
    data:
      json['data'] == null
        ? undefined
        : (json['data'] as Array<any>).map(OverrideFromJSON),
  };
}

export function GetOverridesResponseToJSON(json: any): GetOverridesResponse {
  return GetOverridesResponseToJSONTyped(json, false);
}

export function GetOverridesResponseToJSONTyped(
  value?: GetOverridesResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    data:
      value['data'] == null
        ? undefined
        : (value['data'] as Array<any>).map(OverrideToJSON),
  };
}
